import CssBaseline from "@mui/material/CssBaseline"; // Importa CssBaseline
import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import RoutesContainer from "./components/routes/routesContainer";
import { themeMui } from "./components/styled/theme";
import { persistor, store } from "./store";
import { SnackbarUtilsConfigurator } from "./utils/snackbarUtils";
import { VersionUpdateDialog } from "@accessinformatica/service-worker";

const App = () => (
  <SnackbarProvider maxSnack={10} preventDuplicate>
    <SnackbarUtilsConfigurator />
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={themeMui}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <CssBaseline />
            <VersionUpdateDialog />
            <RoutesContainer />
          </LocalizationProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </SnackbarProvider>
);

export default App;
